import "./Map.scss"
function GoogleMap() {
    return (
        <div className="google-map-container">
            <iframe
                title="Google Map"
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3605.8413490580647!2d81.90861817593334!3d25.343104225774457!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3985497f856b1d35%3A0xf727c4fc418f7b17!2sUnited%20College%20of%20Engineering%20and%20Research!5e0!3m2!1sen!2sin!4v1742556705837!5m2!1sen!2sin"
            ></iframe>
        </div>
    );
}

export default GoogleMap;
